import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

@observer
class DashboardDelete extends Component {
    render() {
        const {
            show, onClose, dashStore, onDelete,
        } = this.props
        const { dashboard, deleteDashboard } = dashStore
        const { name } = dashboard

        return (
            <Modal show={show} onClose={onClose}>
                <ModalHeader
                    style={{
                        textAlign: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '16px',
                        marginBottom: '0px',
                    }}
                >
                    <h1 style={{ width: '430px', textAlign: 'center', textWrap: 'wrap' }}>
                        {i18n.t('dashboard.modal.delete.title')}
                    </h1>
                </ModalHeader>
                <div style={{
                    width: '100%',
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: '18px',
                }}
                >
                    <b>{name}</b>
                </div>
                <ModalFooter
                    style={{
                        marginTop: '0px',
                        padding: '16px',
                    }}
                >
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '32px',
                    }}
                    >
                        <Button
                            cssClass="regular tertiary"
                            onClick={onClose}
                        >
                            {i18n.t('dashboard.modal.delete.button.no')}
                        </Button>
                        <Button
                            cssClass="regular error"
                            onClick={onDelete || (() => {
                                onClose()
                                deleteDashboard(true, name)
                            })}
                        >
                            {i18n.t('dashboard.modal.delete.button.yes')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default DashboardDelete
